import React, { useState } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import DateTime from "./DateTime";
import CurrentTemp from "./CurrentTemp";
import WeatherIcon from "./WeatherIcon";
import DailyForecast from "./DailyForecast";

export default function WeatherSearch(props) {
  const [weatherData, setWeatherData] = useState({ ready: false });
  const [city, setCity] = useState(props.defaultCity);

  function handleResponse(response) {
    console.log(response);
    setWeatherData({
      ready: true,
      coordinates: response.data.coordinates,
      temperature: Math.round(response.data.temperature.current),
      humidity: response.data.temperature.humidity,
      description: response.data.condition.description,
      wind: response.data.wind.speed,
      city: response.data.city,
      icon: response.data.condition.icon,
      date: new Date(response.data.time * 1000),
    });
  }

  function handleSubmit(event) {
    event.preventDefault();
    search();
  }

  function search() {
    const apiKey = "4f25d827925b137070a1t4ad0aa3odaf";
    const apiUrl = `https://api.shecodes.io/weather/v1/current?query=${city}&key=${apiKey}&units=metric`;
    axios.get(apiUrl).then(handleResponse);
  }

  function handleChangeCity(event) {
    setCity(event.target.value);
  }

  if (weatherData.ready) {
    return (
      <div className="weatherSearch">
        <div className="container">
          <div className="row">
            <div className="col-sm"></div>
            <div className="col-sm">
              <form className="SearchFormat" onSubmit={handleSubmit}>
                <div>
                  <div className="Search">
                    <label
                      htmlFor="exampleInputLocation"
                      className="location-label"
                    >
                      Location:
                    </label>
                    <br />
                    <input
                      type="text"
                      className="locationInput"
                      id="exampleInputLocation"
                      placeholder=" Enter your location  🔍"
                      onChange={(event) => handleChangeCity(event)}
                    />
                  </div>
                </div>
              </form>
            </div>
            <div className="col-sm"></div>
          </div>
        </div>

        <div className="WeatherApp">
          <div className="location">
            <h1>{weatherData.city}</h1>
          </div>
          <div className="currentTempContainer">
            <div className="currentWeather">
              <span className="timeDate" id="date-time">
                {weatherData.datetime}
              </span>
              <DateTime dateTime={weatherData.date} />
            </div>
            <div className="row">
              <div className="col-sm">
                <span className="weatherEmoji">
                  <WeatherIcon code={weatherData.icon} size="52" />
                  <img src={weatherData.icon} alt=""></img>
                </span>
              </div>
              <div className="col-sm">
                <CurrentTemp celsiusTemp={weatherData.temperature} />
              </div>
              <div className="col-sm">
                <div className="additionalWeather">
                  Humidity: {weatherData.humidity}%
                  <br />
                  <br />
                  Wind Gusts: {Math.round(weatherData.wind)}mph
                  <br />
                  <br />
                </div>
              </div>
            </div>
            <span className="weatherStatus text-capitalize">
              {" "}
              {weatherData.description}{" "}
            </span>
          </div>
        </div>
        <DailyForecast coordinates={weatherData.coordinates} />
      </div>
    );
  } else {
    search();
    return "Loading...";
  }
}
